﻿import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, LocationModel, EntityModel, SchemaModel, AlarmGroupModel, ResponseDeleteModel } from '../api.models'
import { LoginService } from './api.login.service'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IAlarmGroupsService {
    getAlarmGroups(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getAlarmGroup(id, state?: any): ng.IPromise<AlarmGroupModel>
    getAlarmGroupsOperators(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createAlarmGroup(req): ng.IPromise<AlarmGroupModel>
    deleteAlarmGroup(id): ng.IPromise<ResponseDeleteModel>
}

export class AlarmGroupsService implements IAlarmGroupsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getAlarmGroups(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.alarmGroups.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getAlarmGroup(id, state: any = {}) {
        var get = this.apiResource.alarmGroups.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getAlarmGroupsOperators(req: GridRequestModel, state: any = {}) {
        var getAlarmGroupsOperators: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.alarmGroups['getAlarmGroupsOperators']
        state.request = getAlarmGroupsOperators(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
    
    createAlarmGroup(req): ng.IPromise<AlarmGroupModel> {
        return this.apiResource.alarmGroups.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
    deleteAlarmGroup(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.alarmGroups.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
